import { useEffect, Component } from "react";
import Lenis from "lenis";
import Landing from "@/pages/Landing";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error) {
    console.error("Landing page error:", error);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-[#07090F] p-8 text-center">
          <div>
            <p className="font-display text-3xl text-white">Something went wrong.</p>
            <button
              onClick={() => window.location.reload()}
              className="mt-6 rounded-full bg-[#FFB020] px-6 py-3 font-bold text-[#07090F]"
            >
              Reload the page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const SmoothScroll = () => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return null;
};

function App() {
  return (
    <ErrorBoundary>
      <SmoothScroll />
      <Landing />
    </ErrorBoundary>
  );
}

export default App;
